var map = {
	"./1.png": "oHDn",
	"./2.png": "2TdG",
	"./3.png": "vfr7",
	"./4.png": "YLKb",
	"./5.png": "hVzj",
	"./6.png": "zpvb",
	"./7.png": "Vsue",
	"./8.png": "OH8w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sM/b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon ^\.\/.*\.png$
// module id = sM/b
// module chunks = 97